import { Component, Input } from '@angular/core'

@Component({
  selector: 'lib-form-errors',
  template: `
  <div *ngFor="let control of form.controls | objectToArray">
  <ng-container *ngIf="(control | propertyValues : 0); let controlValue">
      <ng-container *ngFor="let error of errorMsgs | objectToArray">
          <div class="form-errors" *ngIf="controlValue.errors &&
          controlValue.errors[(error | propertyNames)] &&
          controlValue.touched">
              {{control | propertyNames}} {{error | propertyValues : 0}}
          </div>
      </ng-container>
  </ng-container>
</div>
  `,
  styles: []
})
export class NgFormErrorsComponent {

  @Input() form
  @Input() errorMsgs

  constructor() { }
}
